module.exports = __webpack_public_path__ + "static/media/plugs.8d201e54.svg";